import React from 'react'
import { Dropdown } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import type { RouteDef } from '@ztechapps/common.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import { Icon, PortalDropdownMenu, ShowIf } from '@ztechapps/webui.util'
import { AttachConversation } from './AttachConversation'
import { ClearConversation } from './ClearConversation'

export type ConversationActionsProps = { conversationId?: string }

// The document-side conversation actions behind one icon button, so they take the width of one control in
// the composer toolbar: View conversation (when linked), Replace / Attach conversation and Clear conversation (when linked).
export const ConversationActions = ({ conversationId }: ConversationActionsProps) => {
  const conversationItemRoute = useInject<RouteDef>(WebuiIocKey.routes.conversationItem)

  return (
    <Dropdown align="end">
      <Dropdown.Toggle variant="link" aria-label="Conversation actions">
        <Icon name="comments" aria-hidden="true" />
      </Dropdown.Toggle>
      {/* Portalled: TinyMCE's `.tox` reset strips the background and border from every descendant of the editor
          header, so an inline menu would render unstyled. */}
      <PortalDropdownMenu renderOnMount>
        <ShowIf condition={!!conversationId}>
          <Dropdown.Item as={Link} to={conversationItemRoute.altPath({ _id: conversationId ?? '' })}>
            <Icon name="external-link" aria-hidden="true" /> View conversation
          </Dropdown.Item>
        </ShowIf>
        <AttachConversation conversationId={conversationId} />
        <ShowIf condition={!!conversationId}>
          <ClearConversation conversationId={conversationId} />
        </ShowIf>
      </PortalDropdownMenu>
    </Dropdown>
  )
}
